// Örnek servis codiagno login
import axios from '../javascript/custom-axios';
let RESOURCE_NAME = 'express-cargo';

export default {
  add(body) {
    return axios.post(`${RESOURCE_NAME}/add`, body);
  },
  addOutOfArea(body) {
    return axios.post(`${RESOURCE_NAME}/add-out-area`, body, {
      timeout: 0
    });
  },
  updatePriceExcel(body) {
    return axios.put(`${RESOURCE_NAME}/update-priceExcel`, body);
  },
  updateRegionExcel(body) {
    return axios.put(`${RESOURCE_NAME}/update-regionExcel`, body);
  },
  updatePriceList(body) {
    return axios.put(`${RESOURCE_NAME}/update-priceList`, body);
  },
  updateOutOfArea(body) {
    return axios.put(`${RESOURCE_NAME}/update-out-area`, body, {
      timeout: 0
    });
  },
  updateTransportTime(body) {
    return axios.put(`${RESOURCE_NAME}/update-transport-time`, body);
  },
  updateExpiryDate(body) {
    return axios.put(`${RESOURCE_NAME}/update-expiry-date`, body);
  },
  updateFSC(body) {
    return axios.put(`${RESOURCE_NAME}/update-fsc`, body);
  },
  getPriceList(params) {
    return axios.get(`${RESOURCE_NAME}/get-priceList`, { params });
  },
  getOutOfArea() {
    return axios.get(`${RESOURCE_NAME}/get-out-area`, {});
  },
  getRegionExcel(params) {
    return axios.get(`${RESOURCE_NAME}/get-regionExcel`, { params });
  },
  getPriceExcel(id) {
    return axios.get(`${RESOURCE_NAME}/get-priceexcel?Id=${id}`);
  },
  getOutOfAreaExcel(id) {
    return axios.get(`${RESOURCE_NAME}/get-out-area?Id=${id}`);
  },
  updateName(body) {
    return axios.put(`${RESOURCE_NAME}/update-list-name`, body);
  },
  addPeriodicCost(body) {
    return axios.post(`${RESOURCE_NAME}/add-periodic-cost`, body);
  },
  updatePeriodicCost(body) {
    return axios.put(`${RESOURCE_NAME}/update-periodic-cost`, body);
  },
  getPeriodicCost() {
    return axios.get(`${RESOURCE_NAME}/get-periodic-cost`, {});
  },

  /**
   * Update optional Reference ID.
   * @param {*} body
   * @returns {Promise}
   */
  updateOptionalReferenceID(body) {
    return axios.put(`${RESOURCE_NAME}/update-referansId`, body);
  },

  /**
   * Gets out area details.
   * @param {{ ListId: string, Page: number, PageSize: number }} params
   * @returns {Promise}
   */
  getOutAreaDetails(params) {
    return axios.get(`${RESOURCE_NAME}/get-out-area-details`, {params});
  },

  /**
   * Deletes a price list.
   * @param {{ Id: string }} params
   * @returns {Promise}
   */
  deletePriceList(params) {
    return axios.delete(`${RESOURCE_NAME}/delete-pricelist`, {params});
  },

  /**
   * Get costs Excel file.
   * @param {string} id 
   * @returns 
   */
  getCostsExcel(id) {
    return axios.get(`${RESOURCE_NAME}/get-costexcel?Id=${id}`);
  },
  
  updateCostsExcelFile(body) {
    return axios.put(`${RESOURCE_NAME}/update-costExcel`, body);
  } 
};
